import styled from 'styled-components';
import { palette } from 'styled-tools';

import { fontWeight, FontWeights } from '@calm-web/design-system';

export const Wrapper = styled.div`
	height: 100%;
	color: ${palette('gray7')};
	display: flex;
	flex-direction: column;
`;

export const OfferText = styled.h5`
	color: ${palette('gray7')};
	${fontWeight(FontWeights.Medium)};
	margin-bottom: 24px;
`;

export const TrialLink = styled.a`
	text-decoration: underline;
	color: ${palette('blue3')};
`;
